"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useChangeTracker = void 0;
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
/**
 * @param originalEntity The original entity in a clean state
 * @param message The message shown in the Modal when navigating away
 * @returns An object that holds info about the Change Tracker objects
 */
const useChangeTracker = (originalEntity, message) => {
    const [entity, setEntity] = (0, react_1.useState)(originalEntity);
    const [cleanEntity, setCleanEntity] = (0, react_1.useState)(originalEntity);
    const [hasChanges, setHasChanges] = (0, react_1.useState)(false);
    const { navigator } = (0, react_1.useContext)(react_router_dom_1.UNSAFE_NavigationContext);
    const reset = (0, react_1.useCallback)(() => {
        setEntity(cleanEntity);
    }, [cleanEntity]);
    (0, react_1.useEffect)(() => {
        setHasChanges(entity !== cleanEntity);
    }, [entity, cleanEntity]);
    (0, react_1.useEffect)(() => {
        const oldHandler = window.onbeforeunload;
        const cleanupRouteBlocker = navigator.block((tx) => {
            if (window.confirm(message)) {
                cleanupRouteBlocker();
                tx.retry();
            }
        });
        if (!hasChanges) {
            cleanupRouteBlocker();
        }
        window.onbeforeunload = () => {
            if (hasChanges) {
                return message;
            }
        };
        return () => {
            window.onbeforeunload = oldHandler;
            cleanupRouteBlocker();
        };
    }, [hasChanges, message, navigator]);
    return {
        /** The current Entity */
        entity,
        /** Setter for the current Entity */
        setEntity,
        /**  Indicates if the entity and the clean entity is not the same */
        hasChanges,
        /**  Updates the clean entity (e.g. after save) */
        setCleanEntity,
        /**  Sets the entity to the current clean entity (last 'saved' changes) */
        reset,
    };
};
exports.useChangeTracker = useChangeTracker;
//# sourceMappingURL=use-change-tracker.js.map